import type { DomainTaskStatusType } from "@porchpass/api-client";

export function isOnLetter(status: DomainTaskStatusType | undefined): boolean {
  return (
    status === "not_done" ||
    status === "in_review" ||
    status === "correction_needed"
  );
}

export function needsCorrection(
  status: DomainTaskStatusType | undefined,
): boolean {
  return status === "correction_needed";
}
